import firebase from 'firebase';

import {
  encode,
} from 'firebase-encode';

var config = {
  apiKey: "AIzaSyA1rn4-19tmVS-UDKYNiSmLtAVoHgYxCck",
  authDomain: "home-gallery-project.firebaseapp.com",
  databaseURL: "https://home-gallery-project.firebaseio.com",
  storageBucket: "home-gallery-project.appspot.com",
  messagingSenderId: "519762249003"
};

firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(function(user) {
  console.log("onAuthStateChanged: " + user)
  if (user) {
    // Write the new post's data simultaneously in the posts list and the user's post list.
    var updates = {
      '/displayName' : user.displayName || '',
      '/email' : user.email || '',
      '/photoUrl' : user.photoUrl || '',
      '/emailVerified' : user.emailVerified || '',
    };

    user.providerData.forEach(function(profile) {
      updates['/providers/' + encode(profile.providerId) + '/uid'] = profile.uid || '';
      updates['/providers/' + encode(profile.providerId) + '/displayName'] = profile.displayName || '';
      updates['/providers/' + encode(profile.providerId) + '/email'] = profile.email || '';
      updates['/providers/' + encode(profile.providerId) + '/photoURL'] = profile.photoURL || '';
    })

    firebase.database().ref().child('users').child(user.uid).update(updates);
  } else {
    // No user is signed in.
  }
});


module.exports.firebase = firebase;
module.exports.storage = firebase.storage();
module.exports.database = firebase.database();
module.exports.auth = firebase.auth();

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js